import { render, staticRenderFns } from "./SMSCampaignCreateSecondStep.vue?vue&type=template&id=3b38a99c&scoped=true&"
import script from "./SMSCampaignCreateSecondStep.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignCreateSecondStep.vue?vue&type=script&lang=js&"
import style0 from "./SMSCampaignCreateSecondStep.vue?vue&type=style&index=0&id=3b38a99c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38a99c",
  null
  
)

export default component.exports